<template>
  <div>
    <div>
      <div class="flex flex-col">
        <h1 class="text-md border-b border-b2c-grey-600 pb-3 uppercase">{{$t('checkout.shipping-addresses')}}</h1>
        <div v-if="shippingAddressesSaved.length===0">
          <address-form :isShipping="true" />
        </div>

        <div v-else class="mt-4">
          <shipping-addresses-list />

          <div class="flex justify-center mb-20" v-if="!addMore">
            <button class="mt-4 p-4 shadow-md rounded-md
              hover:bg-b2c-red-300 hover:text-white bg-white"
              @click="addMore=true">
                {{$t('addresses.addMore')}}</button>
          </div>

          <div v-else class="my-10 md:px-10 flex flex-col">
            <div class="flex justify-end">
              <button class="hover:text-b2c-red-300 w-3" @click="addMore=false" aria-label="close">
                <svg
                  width="100%"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="times"
                  class="svg-inline--fa fa-times fa-w-11"
                  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
                  <path fill="currentColor" d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
                </svg>
              </button>
            </div>

            <address-form :isShipping="true" v-on:saved="addMore=false" :notShowClose="true" />
          </div>

        </div>
      </div>
    </div>
    <modal name="edit-address" />

    <modal name="are-you-sure" height="auto" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressForm from '@/components/profile/AddressForm.vue';
import ShippingAddressesList from '@/components/profile/ShippingAddressesList.vue';

export default {
  metaInfo() {
    const title = this.$t('titles.addresses');
    return {
      title,
      meta: [
        {
          name: 'description',
          content: 'Your addresses',
        },
      ],
    };
  },

  data() {
    return {
      addMore: false,
    };
  },

  components: {
    AddressForm,
    ShippingAddressesList,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      customer: 'auth/customer',
      billingAddressSaved: 'auth/billingAddress',
      shippingAddressesSaved: 'auth/shippingAddresses',
    }),
  },

};
</script>
